/**
 * Letter spacing design tokens.
 *
 * For use with the following CSS properties:
 *
 *     letter-spacing
 *
 * @see https://system-ui.com/theme
 */
export const letterSpacings = [
  -1.09,
  -0.32,
  -0.22,
  -0.14,
  -0.07,
  0,
  0.07,
  0.32,
  0.75,
]
